import { Text, VStack } from '@genial/components';
import React, { useMemo } from 'react';

import { ClubsApplicationProps } from '../..';
import { InputMoney } from '../../../../../../../../../../components/InputMoney';
import { RiskRating } from '../../../../../../../../../../components/RiskRating';
import { TableContentItemText } from '../../../../../../../../../../components/TableContent';
import { ClubsDetailsEntityNormalized } from '../../../../../../../../../../store/product/types';
import { ClubsAssetController } from '../../../../../../../../../BatchTicket/components/DynamicAsset/hooks/products/Clubs';
import { ProductCard } from '../../../../components/ProductCard';

export interface ClubsInvestCardProps {
  offer: ClubsApplicationProps['offer'];
  offerController: ClubsAssetController;
  details: ClubsDetailsEntityNormalized | null | undefined;
  accountId: number;
}

export const ClubsInvestCard: React.FC<ClubsInvestCardProps> = ({
  offer,
  offerController,
  details,
}) => {
  const id = offer.clubId;
  const detailItems = useMemo(
    () => [
      {
        label: 'Produto',
        value: details?.clubNameNormalized,
      },
      {
        label: 'Aplicação inicial',
        value: details?.minimumApplicationNormalized,
      },
      {
        label: 'Perfil de risco',
        value: (
          <RiskRating
            currentRiskRating={details?.riskRatingLevelNormalized || 0}
            tooltip={details?.riskRatingNormalized || ''}
          />
        ),
      },
      {
        label: 'Condição de resgate',
        value: `Cotização em D+${details?.redemptionQuotationDays} e liquidação em D+${details?.redemptionSettlementDays} após a data de cotização.`,
      },
      {
        label: 'Condição de aplicação',
        value: `Cotização em D+${details?.applicationQuotationDays}`,
      },
      {
        label: 'Movimentação mínima',
        value: details?.minimumMovementNormalized,
      },
      {
        label: 'Data de liquidação',
        value: details?.settlementDateNormalized,
      },
      {
        label: 'Data de cotização',
        value: details?.quotationDateNormalized,
      },
    ],
    [details]
  );

  const {
    control,
    handleInputBlur,
    handleInputClear,
    handleInputFocus,
    handleSubmit,
    hasError,
    helpText,
    helpTextProps,
    isFocused,
    showMessageAdjustUnitPrice,
    currentValueFormatted,
  } = offerController;

  return (
    <>
      <ProductCard
        infos={detailItems}
        productColor="product.clubes"
        title={offer.managerNameNormalized}
        BottomComponent={
          <VStack space="stack.nano">
            <Text color="neutral.black" variant="semibold">
              Valor a investir(R$)
            </Text>
            <InputMoney
              id={`fixedIncome-input${id}`}
              name="createAppliedAmount"
              control={control}
              handleFocus={handleInputFocus}
              handleBlur={handleInputBlur}
              handleSubmit={handleSubmit}
              handleClear={handleInputClear}
              currentValue={currentValueFormatted}
              hasFocus={isFocused}
              minValue={offer.minimumApplication || 0}
              customInputProps={{
                ...{
                  ...(showMessageAdjustUnitPrice && {
                    helpTextProps,
                    helpText,
                  }),
                },
                ...{ ...(isFocused && hasError && { error: hasError }) },
                ...{ ...(isFocused && !hasError && { helpText }) },
              }}
            />
            {showMessageAdjustUnitPrice && !isFocused && (
              <TableContentItemText fontSize="xs" color="neutral.light">
                Ajustado por preço unitário
              </TableContentItemText>
            )}
          </VStack>
        }
      />
    </>
  );
};
